<template>
    <dual-select
        :inputLabel="label"
        name="relations"
        labelKey="name"
        :options="availableOptions"
        @input="handleMultiValue"
        :loading="loading"
        :value="internalValue"
        v-bind="$attrs"
        v-if="multiple"
    />
    <div v-else class="row" :class="{ 'has-danger' : error !== null, 'form-group': !noFormGroup }">
        <label :class="labelClasses" class="form-control-label col-form-label">{{ computedLabel }}</label>
        <div :class="inputHolderClasses">
            <multi-select
                :options="availableOptions"
                :loading="loading"
                label="name"
                :selectedLabel="uLang('app.select')"
                :placeholder="uLang('app.select_an_option')"
                :deselectLabel="uLang('app.press_enter_to_remove')"
                :selectLabel="uLang('app.press_enter_to_select')"
                v-bind="$attrs"
                @input="handleSingleValue"
            />
            <span
                class="help-block form-control-feedback"
                v-if="error != null"
                v-text="error"
            ></span>
        </div>
    </div>
</template>

<script>
    import { DualSelect } from '~/Form/elements';
    import MultiSelect from 'vue-multiselect'

    export default {
        name: 'action-document-select',

        components: {
            DualSelect,
            MultiSelect,
        },

        props: {
            candidate: {
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            inputHolderClasses: {
                type: String,
                required: false,
                default: 'col-md-9 col-xl-10 col-sm-12'
            },
            labelClasses: {
                type: String,
                required: false,
                default: 'col-md-3 col-xl-2 col-sm-12',
            },
            noFormGroup: {
                type: Boolean,
                required: false,
                default: false,
            },
            error: {
                type: String,
                default: null,
            },
            label: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
            value: {
                default: null,
            },
        },

        data() {
            return {
                availableOptions: [],
                internalValue: null,
                loading: false,
            }
        },

        computed: {
            // Display the label + asterisk for required
            computedLabel() {
                return (null !== this.label ? uLang(this.label) : '') + ': ' + (this.required ? '*' : '');
            }
        },

        created() {
            this.loading = true;
            window.axios.get(route('relations.reportable-action-progresses.show', {relation: this.candidate}))
                .then(({data}) => {
                    this.availableOptions = data.data.map(actionProgress => {
                        actionProgress.name = actionProgress.action.name;
                        delete actionProgress.action;
                        return actionProgress;
                    });
                }).catch(err => console.log)
                .finally(() => {
                    this.loading = false;
                    this.internalValue = this.value;
                });

        },

        methods: {
            handleMultiValue(event) {
                this.internalValue = event;

                this.$emit('input', this.internalValue);
            },

            handleSingleValue(event) {
                this.internalValue = [event.id];

                this.$emit('input', this.internalValue);
            },
        }
    }
</script>

<style lang="scss"></style>
